import { Observable } from "rxjs";

export interface INumberOfApprovalRequest {
  myRequest?: number;
  managerRequest?: number;
  hrRequest?: number;
}

export class NumberOfApprovalRequest implements INumberOfApprovalRequest {
  myRequest?: number = 0;
  managerRequest?: number = 0;
  hrRequest?: number = 0;
}
